import type { Board } from '../../../schema/coupon/entry.js';
import type { SystemType } from '../../../schema/system/entry.js';

type GroupTable = Record<number, number>;

const reducedSystems: SystemType[] = ['RSYS', 'USYS'] as const;

/**
 * Groups coupon board outcomes into a selection count table.
 *
 * @param board Coupon board
 * @param systemType System type to count with
 * @returns Grouped outcome selections count
 */
export function groupOutcomesByCount(board: Board, systemType: SystemType): GroupTable {
  const table: GroupTable = {};
  // const table = new Map<number, number>();
  const isReducedSystem = reducedSystems.includes(systemType);

  for (const [idx, outcomeEventGroup] of Object.entries(board.outcomes)) {
    for (const outcomes of outcomeEventGroup) {
      const isMOutcomeSet = board.mOutcomes[Number(idx)] ?? false;
      // Reduced systems with MATH outcomes should not be taken into account.
      // Therefore we count them as '1' to be included since '0' cannot be used,
      // because those isn't considered to be started yet.
      const outcomeCount = isMOutcomeSet && isReducedSystem ? 1 : outcomes.length;

      const count = table[outcomeCount] ?? 0;
      table[outcomeCount] = count + 1;
    }
  }

  return table;
}
